import { ReactElement } from "react";

export const isImplementedIntegration = (integration: string) => {
  return (
    integration === EBAY_INTEGRATION ||
    integration === ETSY_INTEGRATION ||
    integration === POSHMARK_INTEGRATION ||
    integration === MERCARI_INTEGRATION ||
    integration === WHATNOT_INTEGRATION ||
    integration === VINTED_INTEGRATION ||
    integration === DEPOP_INTEGRATION
  );
};

export const EBAY_INTEGRATION = "Ebay" as const;
export const AMAZON_INTEGRATION = "Amazon" as const;
export const ETSY_INTEGRATION = "Etsy" as const;
export const MERCARI_INTEGRATION = "Mercari" as const;
export const POSHMARK_INTEGRATION = "Poshmark" as const;
export const WHATNOT_INTEGRATION = "Whatnot" as const;
export const VINTED_INTEGRATION = "Vinted" as const;
export const DEPOP_INTEGRATION = "Depop" as const;

export type NormalPlatformIntegration =
  | typeof EBAY_INTEGRATION
  | typeof AMAZON_INTEGRATION
  | typeof ETSY_INTEGRATION;
export type ExtensionPlatformIntegration =
  | typeof MERCARI_INTEGRATION
  | typeof POSHMARK_INTEGRATION
  | typeof WHATNOT_INTEGRATION
  | typeof VINTED_INTEGRATION
  | typeof DEPOP_INTEGRATION;
export type OnboardingIntegration =
  | NormalPlatformIntegration
  | ExtensionPlatformIntegration;

export interface KeyedCard {
  key: string;
  element: ReactElement;
}
